/** @jsxImportSource @emotion/react */

import { Typography } from '@mui/material'
import { DescriptionForm, DescriptionPages } from 'components/DescriptionForm'
import { usePlatformsAndSubjects, Props as UsePlatformsAndSubjects } from 'hooks/usePlatformsAndSubjects'
import { SubjectTabs } from 'components/SubjectsTabs'
import { ClassroomTabEnum } from '__generatedTypes__/globalTypes'
import * as classes from './styles'

const platformsAndSubjectsProps: UsePlatformsAndSubjects = {
  filterSubjects: (subject) => !!subject.classroomTab.find(({ tabEnum }) => tabEnum === ClassroomTabEnum.VideoContent),
}

export const DescriptionContent = () => {
  const { subjects, selectedSubject, selectSubject } = usePlatformsAndSubjects(platformsAndSubjectsProps)

  return (
    <>
      <Typography variant="body2" css={classes.title}>
        Page
      </Typography>

      <SubjectTabs
        subjects={subjects}
        selectedSubject={selectedSubject}
        selectSubject={selectSubject}
        css={classes.tabs}
      />

      {selectedSubject?.id && <DescriptionForm page={`${DescriptionPages.VideoContent}:${selectedSubject.id}`} />}
    </>
  )
}
